import React from 'react'
import PropTypes from 'prop-types';
import { Grid, Button, useTheme } from '@material-ui/core';
import GradeOutlinedIcon from '@material-ui/icons/GradeOutlined';
import StandardList from "../Complements/StandardList"
import RenderDescriptionFormRedux from "../Complements/RenderDescriptionFormRedux"
import { makeStyles } from '@material-ui/core/styles';
import Alert from '@material-ui/lab/Alert';

const useStyles = makeStyles((theme) => ({
    buttonFavorites: {
        margin: (3, 0, 2),
        fontWeight: 'bold',
        fontSize: '0.6rem',
        //borderLeft: '3px solid #0073D2',
        color: '#1a1919',
        backgroundColor: "#ffffff",
        width : "200px",
        //fontFamily: 'Ubuntu',
        border: "none",
        "&:hover": {
            backgroundColor: "#ffffff",
            //borderLeft: '3px solid #0073D2',
        }
    },
    buttonStandard: {
        fontSize: '1rem',
        color: '#ffffff',
        borderRadius: '4px',
        '&.Mui-disabled': {
            backgroundColor: "#a7a8a8",
        },
        '&:hover': {
            backgroundColor: "#706D85",
        },
        backgroundColor: "#2E2757",
        //fontFamily: 'MyriadPro-Bold',
    },
}));

const ElectronicRechargesInfoPanel = props => {

    const { listDetail, processPayment, getBack, isFavorites, saveFavorites } = props;

    const classes = useStyles();
    const theme = useTheme()

    return (
        <Grid container style={{
            backgroundColor: theme.palette.type === 'dark' ? '#4a4a4a' : '#fafafa',
            borderRadius: 16,
            padding: 16
        }}>
            <Grid item xs={12} md={12} lg={12} xl={12}>
                {
                    isFavorites ?
                    <Alert severity="info">Esta referencia se encuentra registrada como favorita.</Alert> :
                    <Button
                        id={"add_favourite_agrement_btn"}
                        size="small"
                        variant="contained"
                        startIcon={<GradeOutlinedIcon />}
                        onClick = { saveFavorites }
                        className = { classes.buttonFavorites }
                    >Agregar a favoritos</Button> 
                }
            </Grid>
            <Grid item xs={12} md={12} lg={12} xl={12}>
                <RenderDescriptionFormRedux  
                    label = "Concepto" 
                    onSubmit = {(data) => processPayment(data) } 
                    positive = {'Pagar'} 
                    getBack= {getBack}
                    classes = {classes}
                />
            </Grid>
            <Grid item xs={12} md={12} lg={12} xl={12}>
                <StandardList
                    dataList ={ listDetail}
                    primary = {'title'}
                    secondary = {'data'}
                    selectItem = {(val) => {/*console.log(val)*/}}
                    icon = {'school'}
                />
            </Grid>
            
        </Grid>
    )
}

ElectronicRechargesInfoPanel.propTypes = {
    listDetail: PropTypes.array.isRequired,
    processPayment: PropTypes.func.isRequired,
    getBack: PropTypes.func.isRequired,
    isFavorites: PropTypes.bool.isRequired,
    saveFavorites : PropTypes.func.isRequired
};

export default ElectronicRechargesInfoPanel
